export const StudentEnrolmentHealth = {
  NOT_STARTED: 'NOT_STARTED',
  WITHDRAWN: 'WITHDRAWN',
  DELETED: 'DELETED',
  ON_TRACK: 'ON_TRACK',
  SLIPPING: 'SLIPPING',
  BEHIND: 'BEHIND',
  COMPLETED: 'COMPLETED',
  PAUSED: 'PAUSED',
} as const;

export type StudentEnrolmentHealth =
  (typeof StudentEnrolmentHealth)[keyof typeof StudentEnrolmentHealth];

export const StudentRecentPaceStatus = {
  NONE: 'NONE',
  SLOW: 'SLOW',
  GOOD: 'GOOD',
  GREAT: 'GREAT',
} as const;

export type StudentRecentPaceStatus =
  (typeof StudentRecentPaceStatus)[keyof typeof StudentRecentPaceStatus];

export const StudentWorkPlacementJourneyStatus = {
  AWAITING_CHECKLIST: 'AWAITING_CHECKLIST',
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  AWAITING_PLACEMENT: 'AWAITING_PLACEMENT',
  INTERVIEWING: 'INTERVIEWING',
  AWAITING_CONTRACT: 'AWAITING_CONTRACT',
  PLACED: 'PLACED',
  COMPLETED: 'COMPLETED',
} as const;

export type StudentWorkPlacementJourneyStatus =
  (typeof StudentWorkPlacementJourneyStatus)[keyof typeof StudentWorkPlacementJourneyStatus];

export const StudentWorkPlacementJourneyStageOrigin = {
  MANUAL: 'MANUAL',
  AUTO: 'AUTO',
} as const;

export type StudentWorkPlacementJourneyStageOrigin =
  (typeof StudentWorkPlacementJourneyStageOrigin)[keyof typeof StudentWorkPlacementJourneyStageOrigin];

export const PRE_PLACEMENT_JOURNEY_STAGES = [
  'AWAITING_CHECKLIST',
  'AWAITING_APPROVAL',
  'AWAITING_PLACEMENT',
  'INTERVIEWING',
  'AWAITING_CONTRACT',
] as const satisfies readonly StudentWorkPlacementJourneyStatus[];

export type PrePlacementJourneyStage = (typeof PRE_PLACEMENT_JOURNEY_STAGES)[number];

export const journeyStatusLabel = {
  AWAITING_CHECKLIST: 'Awaiting docs',
  AWAITING_APPROVAL: 'Pending approval',
  AWAITING_PLACEMENT: 'Sourcing',
  INTERVIEWING: 'Interviewing',
  AWAITING_CONTRACT: 'Contracts',
  PLACED: 'Placed',
  COMPLETED: 'Completed',
} as const satisfies Record<StudentWorkPlacementJourneyStatus, string>;

export const StudentEmployerPlacementStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  AWAITING_EVIDENCE: 'AWAITING_EVIDENCE',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;

export type StudentEmployerPlacementStatus =
  (typeof StudentEmployerPlacementStatus)[keyof typeof StudentEmployerPlacementStatus];

export const StudentCourseEnrolmentStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  WITHDRAWN: 'WITHDRAWN',
  DELETED: 'DELETED',
  PAUSED: 'PAUSED',
  PENDING_REVIEW: 'PENDING_REVIEW',
} as const;

export type StudentCourseEnrolmentStatus =
  (typeof StudentCourseEnrolmentStatus)[keyof typeof StudentCourseEnrolmentStatus];

export const StudentScheduleItemType = {
  UNIT: 'UNIT',
  CONVERSATION: 'CONVERSATION',
  ASSESSMENT: 'ASSESSMENT',
  WORK_PLACEMENT_WORKBOOK: 'WORK_PLACEMENT_WORKBOOK',
} as const;

export type StudentScheduleItemType =
  (typeof StudentScheduleItemType)[keyof typeof StudentScheduleItemType];
